export default "__VITE_ASSET__d82685b6__"